import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { IBespokeAgreement } from '../interfaces/bespoke-agreement';
import { IBespokeAgreementFilter } from '../interfaces/bespoke-agreement-filter';
import { EditService } from './edit.service';

import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class BespokeAgreementsService extends EditService<
  IBespokeAgreement,
  IBespokeAgreementFilter
> {
  url = '/api/agreement';
  entityTitle = 'BespokeAgreements';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getOrganisationsForBespoke(isCustomer: boolean): Promise<any> {
    return this.handleRequest(
      this.http.get(`${this.url}/getOrganisationsForBespoke?isCustomer=${isCustomer}`),
      this.handlersFactory.getForReadAll(),
    ).then(this.extractData);
    //return .toPromise()
    //    .then(this.extractData)
    //    .catch(this.handleError);
  }

  getPage(filter: IBespokeAgreementFilter): Promise<any> {
    let params = this.constructHttpParams(filter);
    return this.handleRequest(
      this.http.get(this.url + '/getpage', { params: params }),
      this.handlersFactory.getForReadByFilter(),
    ).then(this.extractData);
  }

  getCustomerAgreements(customerId: number): Promise<any> {
    return this.handleRequest(
      this.http.get(this.url + `/${customerId}/getcustomeragreements`),
      this.handlersFactory.getForReadByFilter(),
    ).then(this.extractData);
  }

  //getPage(filterCommand: IBespokeAgreementFilter): Promise<any> {
  //    console.log(filterCommand)
  //    const params = new URLSearchParams();
  //    Object.keys(filterCommand).forEach(prop => {
  //        if (Array.isArray(filterCommand[prop])) {
  //            (filterCommand[prop] as any[]).forEach((p, i) => {
  //                params.set(`${prop}[${i}]`, p);
  //            });
  //        } else {
  //            params.set(prop, filterCommand[prop]);
  //        }
  //    });
  //    return this.handleRequest(
  //        this.http.get(this.url + '/getpage', { params: this.constructHttpParams(params) }),
  //        this.handlersFactory.getForReadByFilter());
  //}

  //public extractData(res: any) {
  //    return res;
  //}
  //
  //public handleError(errorResponse: HttpErrorResponse | any) {
  //    let fullErrorMessage: string;
  //    if (errorResponse instanceof HttpErrorResponse) {
  //        const error = errorResponse.error || JSON.stringify(errorResponse);
  //        fullErrorMessage = `${errorResponse.status} - ${errorResponse.statusText || ''} ${error}`;
  //    } else {
  //        fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
  //    }
  //    console.error(fullErrorMessage);
  //    return Promise.reject(fullErrorMessage);
  //}
}
